import React from 'react';
import '../../css/homePage.css';
import { NejcastejsiZadosti } from '../index.js';

const HomePageBottomSectionPrimary = () => {
    return <NejcastejsiZadosti/>;
};

export default HomePageBottomSectionPrimary;